const ImageFilter = Object.freeze({
    PENCIL: 6,
    DEFAULT: 6,
    AQUA: 12
});
export default ImageFilter;
